import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup, ToastErrorTile } from "uikit/components";
import { useGenerateFederationSummary } from "hooks/federationSummary";
import styles from "./FederationSummaryPage.module.styl";
import { toast } from "react-toastify";
import FederationSummaryView from "components/federationSummary/FederationSummaryView/FederationSummaryView";
import { Helmet } from "react-helmet-async";

export default function FederationSummaryPage() {
    const { federationId } = useParams();

    const [result, setResult] = useState(null);

    const [showPlaceHolder, setShowPlaceHolder] = useState(false);

    const { build: generateFederationSummary, isLoading: isGeneratingFederationSummary } =
        useGenerateFederationSummary({
            onSuccess: (report) => setResult(report),
            onError: (error) => {
                const data = error.response.data;
                if (data.status === 422) setShowPlaceHolder(true);
                else toast.error(<ToastErrorTile error={error} />);
            },
        });

    useEffect(() => {
        generateFederationSummary(federationId);
    }, [federationId, generateFederationSummary]);

    if (isGeneratingFederationSummary) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text"/>
            </Popup>
        );
    }

    if (showPlaceHolder) {
        return (
            <Heading size={"h1"} className={styles.placeHolder} name="error-header">
                Возникла техническая ошибка. Попробуйте ещё раз.
            </Heading>
        );
    }

    if (result != null) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Центр мониторинга и развития вида спорта: ${result.federationName}`}
                    />
                    <meta
                        name="application-name"
                        content={`Центр мониторинга и развития вида спорта: ${result.federationName}`}
                    />
                    <title>Центр мониторинга и развития вида спорта: {result.federationName}</title>
                </Helmet>
                <Heading size={"h1"} name="federation-summary-heading">
                    Центр мониторинга и развития вида спорта: {result.federationName}
                </Heading>
                <FederationSummaryView
                    currentDate={result.currentDate}
                    federationId={result.federationId}
                    federationSummaryData={result.federationSummaryData}
                />
            </>
        );
    }
}
